export default __webpack_public_path__ + "static/media/header-vid.870ac7e3.webm";